module.exports = __webpack_public_path__ + "static/media/手部识别与追踪.73633bf0.png";